<template>
  <div class="preview-container">
    <previewer
      :activities="previewList">
    </previewer>
    <button
      class="uk-button button-style uk-width-1-1"
      @click="onChange">
      <span class="uk-text-capitalize">{{$t('general.change')}}</span>
      <span class="uk-text-lowercase">{{$t('general.file')}}</span>
    </button>
  </div>
</template>

<script>
  import previewer from '../../../content-preview/previewer'

  export default {
    name: 'resource-preview',
    components: {
      previewer
    },
    props: ['previewList'],
    methods: {
      onChange() {
        this.$emit('changeFile')
      }
    }
  }
</script>


<style scoped lang="scss">
  @import '../../../../styles/colours';

  .button-style {
    font-size: 20px;
    margin-top: 16px;
    font-weight: bold;
    border-radius: 2px;
    border: solid 2px #7a8b99;
    color: $slate;
    height: 56px;
    background-color: $lightest-gray;
    &:hover {
      box-shadow: 3px 5px 8px 0 rgba(0, 0, 0, 0.24);
      border: solid 2.8px white;
      background-color: white;
    }
  }

  .preview-container {
    max-width: 600px;
  }

</style>
